import {
    styledAvatar,
    styledName,
    styledUser,
} from './styles'
import {AvatarIconOverride} from '../Avatar/UserAvatar/types'
import React from 'react'
import UserAvatar from '../Avatar/UserAvatar'
import {isPropsObjectEqual} from 'utils/props'
import {styled} from 'stitches/config'

const StyledUser = styled('div', styledUser)
const StyledAvatar = styled('div', styledAvatar)
const StyledName = styled('span', {
    display: 'block',
    ...styledName,
})
const StyledRealName = styled(StyledName, {color: '$secondaryText'})

type UserViewProps = {
    avatarOnly?: boolean
    iconOverride?: AvatarIconOverride
    iconURL?: string
    isConnected: boolean
    isIdle: boolean
    nameOnly?: boolean
    size?: 'small'
    userName?: string
    realName?: string
}

const UserView: React.FC<UserViewProps> = (props) => {
    const {
        avatarOnly,
        iconOverride,
        iconURL,
        isConnected,
        isIdle,
        nameOnly,
        realName,
        size,
        userName,
    } = props

    return (
        <StyledUser>
            {!nameOnly && (
                <StyledAvatar name={!avatarOnly}>
                    <UserAvatar
                        connected={isConnected}
                        iconOverride={iconOverride}
                        idle={isIdle}
                        name={userName}
                        size={size}
                        src={iconURL}
                    />
                </StyledAvatar>
            )}
            {!avatarOnly && (
                <div>
                    <StyledName title={userName}>{userName}</StyledName>
                    {!!realName && <StyledRealName title={realName}>{realName}</StyledRealName>}
                </div>
            )}
        </StyledUser>
    )
}

UserView.defaultProps = {
    avatarOnly: false,
    iconOverride: undefined,
    iconURL: undefined,
    nameOnly: false,
    realName: undefined,
    size: undefined,
    userName: undefined,
}

export default React.memo(UserView, isPropsObjectEqual)
